var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 48,
    viewBox: "0 0 58 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.6693 8.00008C55.6693 5.06675 53.2693 2.66675 50.3359 2.66675H7.66927C4.73594 2.66675 2.33594 5.06675 2.33594 8.00008M55.6693 8.00008V40.0001C55.6693 42.9334 53.2693 45.3334 50.3359 45.3334H7.66927C4.73594 45.3334 2.33594 42.9334 2.33594 40.0001V8.00008M55.6693 8.00008L29.0026 26.6667L2.33594 8.00008",
    stroke: "#008080",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.96791b9a2eede7bceef57d81d6189a87.svg";
export { ForwardRef as ReactComponent };